import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Settings, Mail, Users } from 'lucide-react';

interface SettingsLayoutProps {
  children: React.ReactNode;
}

export function SettingsLayout({ children }: SettingsLayoutProps) {
  const location = useLocation();
  const { orgId } = useParams<{ orgId: string }>();

  const menuItems = [
    { icon: Users, label: 'Members & Invites', path: `/settings/organizations/${orgId}/members` },
    { icon: Mail, label: 'Gmail Integration', path: `/settings/organizations/${orgId}/gmail` },
    // Add more settings tabs here as needed
  ];

  return (
    <div className="max-w-7xl mx-auto py-6">
      <div className="flex items-center mb-6">
        <Settings className="w-6 h-6 mr-2" />
        <h1 className="text-2xl font-bold text-gray-100">Settings</h1>
      </div>

      <div className="flex space-x-1 mb-6">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center space-x-3 px-6 py-3 rounded-lg transition-colors
              ${location.pathname === item.path 
                ? 'bg-gray-800 text-white' 
                : 'text-gray-300 hover:bg-gray-700'}`}
          >
            <item.icon className="w-5 h-5" />
            <span className="font-medium">{item.label}</span>
          </Link>
        ))}
      </div>

      {children}
    </div>
  );
} 